export default {
  bind (el, binding, vnode) {
    const instance = vnode.componentInstance
    if (instance) {
      const input = instance.$el.querySelector('.el-input__inner')
      if (input) {
        const inputHandler = () => {
          instance.$emit('input', input.value.trim())
        }
        const enterHandler = (event) => {
          let keyCode = event.keyCode || event.which || event.charCode
          if (keyCode === 13) {
            instance.$emit('input', input.value.trim())
          }
        }
        input.addEventListener('blur', inputHandler)
        input.addEventListener('keyup', enterHandler)
        instance.$on('hook:destroyed', () => {
          input.removeEventListener('blur', inputHandler)
          input.removeEventListener('keyup', enterHandler)
        })
      }
    }
  }
}
